var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("basic-transition shadow-" + (_vm.expanded && _vm.shadow)),attrs:{"id":("container-" + _vm.id)}},[_c('div',{staticClass:"basic-transition",attrs:{"id":("content-" + _vm.id)}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }